import { Pipe, PipeTransform } from '@angular/core';
import { formatString } from '../utils/string-utils';

/**
 * Formats a string, replacing placeholders with given values.
 * Example: <div>{{ LOCALIZATION.albumDescription | formatString: album.pages }}</div>
 * Where LOCALIZATION.albumDescription = <albumDescription>Contains {0} items</albumDescription>
 */
@Pipe({ name: 'formatString' })
export class FormatStringPipe implements PipeTransform {
	transform(template: string, ...args: any[]): string {
		if (!template) {
			return "";
		}
		return formatString(template, ...args);
	}
}
